import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './util';

export class ExperimentService extends BaseService {
  static async getExperimentData() {
    try {
      const response = await this.request({ auth: true }, 'v2').get('/experiment');
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}